import { MessageCircle } from "lucide-react";

const PHONE = "447426848476";
const PREFILLED = "Hi ReptiCraft, I'd like to ask about a custom enclosure...";

/**
 * Floating WhatsApp chat button.
 * Visible on every page, opens wa.me/{number} in a new tab with a pre-filled message.
 * Late-night reptile keepers (the ones we don't catch on the 9-5 phone line) live in
 * WhatsApp — this is where they'll convert.
 */
const WhatsAppButton = () => {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(PREFILLED)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with ReptiCraft on WhatsApp"
      data-testid="whatsapp-chat-button"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#1eba56] text-white px-4 py-3 rounded-full shadow-lg shadow-black/40 transition-all hover:scale-105 active:scale-95"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-semibold">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
